import axios from 'axios'
import qs from 'qs'
import * as types from '../vuex/types'
import store from '@/vuex/store'
import router from '@/router'

export const URL_ARRAY = [];

// axios 配置
axios.defaults.timeout = 45000;
axios.defaults.withCredentials = false;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.baseURL = types.SERVER_IP;


axios.interceptors.request.use(config => {
  if (config.closeLoading) {
    return config;
  }
  // 教师首页不显示loading
  if (window.location.href.indexOf("#/moduleOption") >= 0) {
    return config;
  }
  // 不显示loading的URL：H5答题上传任务
  if (config.url.indexOf("/exercises/updateUsedTime") >= 0) {
    return config
  }
  if (config.url.indexOf("/getServerIp") === -1) {
    URL_ARRAY.push(config.url);
  }
  return config
}, error => {
  return Promise.reject(error)
});

// POST传参序列化
axios.interceptors.request.use((config) => {
  if (config.method === 'get') {
    config.data = qs.stringify(config.data);
  }
  return config;
}, (error) => {
  console.log("错误的传参");
  return Promise.reject(error);
});

// 返回状态判断
axios.interceptors.response.use((res) => {
  if (parseInt(res.data.msgCode) < 0 && parseInt(res.data.msgCode) != -4 && parseInt(res.data.msgCode) != -5) {
    return Promise.reject(res);
  }
  if (parseInt(res.data.msgCode) == -4) {
    store.dispatch('setSignOut');
    let u = navigator.userAgent, app = navigator.appVersion;
    let browserInfo = {
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
      iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1 //是否iPad
    };
    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (window.location.href.indexOf("mobileExamination") > 0) {
      router.replace({path: '/mobileExamination'});
    } else {
      if (browserInfo.mobile || browserInfo.iPad || browserInfo.iPhone|| browserInfo.ios|| browserInfo.android) {
        router.replace({path: '/mobileLogin'});
      } else {
        router.replace('/login');
      }
    }

  }
  if (parseInt(res.data.msgCode) == -5) {
    store.dispatch('setSignOut');
    router.replace('/noaccess');
  }
  for (var i = 0; i <= URL_ARRAY.length; i++) {
    if (URL_ARRAY[i] === res.config.url) {
      URL_ARRAY.splice(i, 1)
    }
  }
  if ("用户未登录" === res.data.msg) {
    let u = navigator.userAgent;
    let browserInfo = {
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
      iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1 //是否iPad
    };
    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (browserInfo.mobile || browserInfo.iPad || browserInfo.iPhone|| browserInfo.ios|| browserInfo.android) {
      router.replace({path: '/mobileLogin'});
    } else {
      router.replace('/login');
    }
  }
  return res;
}, (error) => {
  let array = URL_ARRAY;
  for (var i = 0; i <= array.length; i++) {
    URL_ARRAY.splice(i, 1)
  }
  return Promise.reject(error);
});

export function post(url, params, config) {
  config = config ? config : {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
  return new Promise((resolve, reject) => {
    axios.post(url, params, config)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 上传图片
export function uploadFile(url, params, config) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, config)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
      .catch((error) => {

        reject(error)
      })
  })
}

export function get(url, config) {
  return new Promise((resolve, reject) => {
    axios.get(url, config)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios.put(url, params)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function del(url) {
  return new Promise((resolve, reject) => {
    axios.delete(url)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 下载
export function download(url, param) {
  if (typeof (param) !== 'undefined' && param != null) {
    url = url + '?' + qs.stringify(param);
  }
  // let headers = {
  //   'token': sessionStorage.getItem('access_token')
  // };
  return new Promise((resolve, reject) => {
    // axios.request({url: url, method: 'get', responseType: 'blob', headers: headers})
    axios.request({url: url, method: 'get', responseType: 'blob'})
      .then(res => {
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = window.URL.createObjectURL(res.data);
        link.setAttribute('download', param.name);
        document.body.appendChild(link)
        link.click();
      })
      .catch(err => reject(err));
  });
}

export default {
  Login(params) {
    return get(types.TEACH_PATH + '/login?' + qs.stringify(params));
  }, Test() {
    return get('teacher/topicbank/find');
  }, LoginPost(params) {
    return post(types.TEACH_PATH + '/login', qs.stringify(params));
  }, LoginAuto() {
    return get(types.TEACH_PATH + '/autoLogin');
  }, getLoginCount() {
    return get(types.TEACH_PATH + '/loginLogs/count');
  }, GetServerIp() {  //查询服务器Ip
    return get(types.TEACH_PATH + '/getServerIp');
  }, getTableScreenWidth() {
    return get(types.TEACH_PATH + '/bc/exercises/getScreenWidth');
  }, getMenus(params) {
    return post(types.TEACH_PATH + '/getMenus', {});
  }, Logout(params) {
    return get(types.TEACH_PATH + '/logout?' + qs.stringify(params));
  }, //=================================== 学生管理 ===================================
  GetClassInfoById(param) {
    return get(types.TEACH_PATH + '/classManager/getClassInfoById?' + qs.stringify(param));
  }, GetStudentsByClassId(param) {
    return get(types.TEACH_PATH + '/classManager/getStudentsByClassId?' + qs.stringify(param));
  }, GetStudentsByClassIdByFenYe(param) {
    return get(types.TEACH_PATH + '/classManager/getStudentsByClassIdByFenYe?' + qs.stringify(param));
  }, CreateStudent(param) {
    return post(types.TEACH_PATH + '/classManager/createStudent', qs.stringify(param));
  }, importStudent(param) {
    let config = {headers: {'Content-Type': 'multipart/form-data;'}};
    return post(types.TEACH_PATH + '/classManager/importStudent', param, config);
  }, UpdateStudent(param) {
    return post(types.TEACH_PATH + '/classManager/updateStudent', qs.stringify(param));
  }, DelStudent(param) {
    return del(types.TEACH_PATH + '/classManager/deleteStudent?' + qs.stringify(param));
  }, DelStudentList(param) {
    let config = {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
    return post(types.TEACH_PATH + '/classManager/deleteStudentList', param, config);
  }, DelExerciseList(param) {
    let config = {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
    return post(types.TEACH_PATH + '/exercises/delExerciseList', param, config);
  }, resetPassword(param) {
    return post(types.TEACH_PATH + '/classManager/resetPassword', qs.stringify(param));
  }, //=================================== 个人信息 ===================================
  confirmPassWord(param) {
    return post(types.TEACH_PATH + '/userInfo/confirmPassword', qs.stringify(param));
  }, resetPassWord(param) {
    return post(types.TEACH_PATH + '/userInfo/resetPassword', qs.stringify(param));
  }, saveHeadPortrait(param) {
    return get(types.TEACH_PATH + '/userInfo/saveHeadPortrait?' + qs.stringify(param));
  }, //=================================== 班级管理 ===================================
  findTeacherClass(params) {
    return get(types.TEACH_PATH + '/classManager/getClassListByCreator?' + qs.stringify(params));
  }, GetMyGivingClasses(param) {
    return get(types.TEACH_PATH + '/bc/class/getGivingClassList?' + qs.stringify(param));
  }, changeMasterByClassId(params) {
    return post(types.TEACH_PATH + '/classManager/changeMaster', qs.stringify(params));
  }, quitClassByClassId(params) {
    return post(types.TEACH_PATH + '/classManager/quitClass', qs.stringify(params));
  }, FindClassMajorTypes(params) {
    return get(types.TEACH_PATH + '/bc/class/getClassMajorType?' + qs.stringify(params));
  }, FindClassMajors(param) {
    return get(types.TEACH_PATH + '/bc/class/getClassMajors?' + qs.stringify(param));
  }, FindGradeYear(param) {
    return get(types.TEACH_PATH + '/bc/class/getClassYear?' + qs.stringify(param));
  }, FindClass(param) {
    return get(types.TEACH_PATH + '/bc/class/getClass?' + qs.stringify(param));
  }, addSelectClass(param) {
    let config = {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
    return post(types.TEACH_PATH + '/classManager/addSelectClass', param, config);
  }, //=================================== 上传图片 ===================================
  uploadImage(params) {
    let config = {headers: {'Content-Type': 'multipart/form-data'}}
    return post(types.TEACH_PATH + '/uploadResource', params, config);
  }, uploadImageToFileServer(params) {
    let config = {headers: {'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundarydrvjReI8loqD3G2g'}};
    return post(types.TEACH_PATH + '/uploadResource', params, config);
    //return post(types.TEACH_PATH+'/teach/send/topic/spUpload',params,config)
    //return post('http://192.168.1.143:8080/xufile/file/upload',params,config);
  }, //===================================== 试题 =====================================
  FindTopicsInfo(param) {
    return get(types.TEACH_PATH + '/send/topic/findTopicsInfo?' + qs.stringify(param));
  }, ShowSelectance(param) {
    return get(types.TEACH_PATH + '/send/topic/showSelectance?' + qs.stringify(param));
  }, StuSubmitStatus(param) {
    return get(types.TEACH_PATH + '/send/topic/stuSubmitStatus?' + qs.stringify(param));
  }, findClassId(param) {
    return get(types.TEACH_PATH + '/send/topic/findClassId?' + qs.stringify(param));
  }, //==================================== 资源中心 ====================================
  uploadFileOfResource(params) {
    let config = {headers: {'Content-Type': 'multipart/form-data'}, closeLoading: true};
    return post(types.RESOURCE_PATH + '/upload', params, config);
  }, uploadPicFileOfResource(params) {
    let config = {headers: {'Content-Type': 'multipart/form-data'}};
    return post(types.RESOURCE_PATH + '/upload', params, config);
  }, //==================================== 课程管理 ====================================
  GetMyCourses(param) {
    return get(types.TEACH_PATH + '/bc/course/getMyCourses?' + qs.stringify(param));
  }, selectCoursesIfDel(param) {
    return get(types.TEACH_PATH + '/bc/course/selectCoursesIfDel?' + 'courseId=' + param);
  }, GetSchoolCourses(param) {
    return get(types.TEACH_PATH + '/bc/course/getSchoolCourses?' + qs.stringify(param));
  }, CreateTeachCourse(param) {
    return post(types.TEACH_PATH + '/bc/course/createTeachCourse?' + qs.stringify(param));
  }, CreateTeachCourseList(param) {
    return post(types.TEACH_PATH + '/bc/course/createTeachCourseList?' + qs.stringify(param));
  }, DeleteTeachCourse(param) {
    return del(types.TEACH_PATH + '/bc/course/deleteTeachCourse?' + qs.stringify(param));
  }, //==================================== 新教案 ====================================
  deleteShareSchool(param) {
    return get(types.TEACH_PATH + '/preparinglesson/teachingPlan/deleteShareSchool?' + qs.stringify(param));
  }, //教案页面拖拽试题
  addExerciseToProcess(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/exercises/addExerciseToProcess', param, config);
  }, //删除教学过程中一道试题
  deleteExerciseInProcess(param) {
    return post(types.TEACH_PATH + '/exercises/deleteExerciseInProcess', qs.stringify(param));
  }, //删除教学过程中一类试题
  deleteAClassOfExercisesInProcess(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/exercises/deleteAClassOfExercisesInProcess', param, config);
  }, //教学过程移动试题
  moveExerciseInProcess(param) {
    return post(types.TEACH_PATH + '/exercises/moveExerciseInProcess', qs.stringify(param));
  }, updateAClassOfScoreInProcess(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/exercises/updateAClassOfScoreInProcess', param, config);
  }, //查询教学过程试题列表
  selectExercisesInProcess(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/exercises/selectExercisesInProcess', param, config);
  }, //更新教学过程试题分数信息
  updateExercisesInProcess(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/exercises/updateExercisesInProcess', param, config);
  }, //删除教学过程中的所有试题
  deleteAllExerciseInProcess(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/exercises/deleteAllExerciseInProcess', param, config);
  }, //根据id查询试题信息
  selectExercisesByPk(param) {
    return get(types.TEACH_PATH + '/exercises/selectExercisesByPk?' + qs.stringify(param));
  }, //根据id查询试题信息
  selectExercisesByBindTextbook(param) {
    return get(types.TEACH_PATH + '/exercises/selectExercisesByBindTextbook?' + qs.stringify(param));
  }, selectExercisesByHistoryId(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/exercises/selectExercisesByHistoryId', param, config);
  }, //根据试题id查询章列表
  selectStampByExercisesId(param) {
    return get(types.TEACH_PATH + '/exercisesCommon/selectStampByExercisesId?' + qs.stringify(param));
  }, //查询试题所有划线列表
  selectLineAll(param) {
    return get(types.TEACH_PATH + '/exercisesCommon/selectLineAll?' + qs.stringify(param));
  }, //=================================== 试题 ===================================

  // 创建试题
  createExercises(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/exercises/createExercises', param, config);
  }, // 修改试题
  updateExercises(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/exercises/updateExercises', param, config);
  }, // 删除试题
  deleteExercises(param) {
    return post(types.TEACH_PATH + '/exercises/deleteExercises?' + qs.stringify(param));
  }, //================ 表格 ================
  getBasicTableTemplate() {
    return get(types.TEACH_PATH + '/bc/exercises/getBasicTableTemplate');
  }, getBasicTableElementByTemplateId(param) {
    return get(types.TEACH_PATH + '/bc/exercises/getBasicTableElementByTemplateId?' + qs.stringify(param));
  }, getStampList(param) {
    return get(types.TEACH_PATH + '/exercisesCommon/selectStampByBankId?' + qs.stringify(param));
  }, getLineList(param) {
    return get(types.TEACH_PATH + '/exercisesCommon/selectLineByBankId?' + qs.stringify(param))
  }, //================ 获取试题库下面的所有章节List =============
  getChapterList(param) {
    return get(types.TEACH_PATH + '/exerciseChapter/getChapterBankList?' + qs.stringify(param))
  }, getSectionList(param) {
    return get(types.TEACH_PATH + '/exerciseSection/getSectionChapterList?' + qs.stringify(param))
  },

  //================ 试题old =============
  findBillElementListByTemplateId(param) {
    return get(types.RESOURCE_PATH + '/center/findBillElementListByTemplateId?' + qs.stringify(param));
  }, //================================= 试题浏览 =================================
  getKnowledgeListByCourseId(param) {
    return get(types.TEACH_PATH + '/bc/knowledge/selectKnowledge?' + qs.stringify(param));
  }, GetMyExercisesBankList(param) {
    return get(types.TEACH_PATH + '/exerciseBank/getMyExercisesBankList?' + qs.stringify(param));
  }, GetExercisesTypeListByBank(param) {
    return get(types.TEACH_PATH + '/exerciseBank/getExercisesTypeListByBank?' + qs.stringify(param));
  }, GetExercisesList(param) {
    return post(types.TEACH_PATH + '/exercises/selectExercisesByBankIds?' + qs.stringify(param));
  }, GetExercisesPage(param) {
    return get(types.TEACH_PATH + '/exercises?' + qs.stringify(param));
  }, GetExercisesInfoList(param) {
    return get(types.TEACH_PATH + '/exercises/list?' + qs.stringify(param));
  }, bindExercises(param) {
    return put(types.TEACH_PATH + '/exercises/bindExercises?', qs.stringify(param));
  }, unbindExercises(param) {
    return put(types.TEACH_PATH + '/exercises/unbindExercises?', qs.stringify(param));
  }, bindExercisesSysInfo(param) {
    return put(types.TEACH_PATH + '/exercises/bindExercisesSysInfo?', qs.stringify(param));
  }, unbindExercisesSysInfo(param) {
    return put(types.TEACH_PATH + '/exercises/unbindExercisesSysInfo?', qs.stringify(param));
  }, bindExercisesKnowledges(param) {
    return put(types.TEACH_PATH + '/exercises/bindExercisesKnowledges?', qs.stringify(param));
  }, unbindExercisesKnowledges(param) {
    return put(types.TEACH_PATH + '/exercises/unbindExercisesKnowledges?', qs.stringify(param));
  }, bindTextbooks(param) {
    return put(types.TEACH_PATH + '/exercises/bindTextbooks?', qs.stringify(param));
  }, unbindTextbooks(param) {
    return put(types.TEACH_PATH + '/exercises/unbindTextbooks?', qs.stringify(param));
  }, bindExercisesPaper(param) {
    return put(types.TEACH_PATH + '/exercises/bindExercisesPaper?', qs.stringify(param));
  }, unbindExercisesPaper(param) {
    return put(types.TEACH_PATH + '/exercises/unbindExercisesPaper?', qs.stringify(param));
  }, GetAllExercisesList(param) {
    return post(types.TEACH_PATH + '/exercises/selectAllExercisesByBankIds?' + qs.stringify(param));
  }, GetMaxNumOfTypeByBankIdst(param) {
    return post(types.TEACH_PATH + '/exercises/selectMaxNumOfTypeByBankIds?' + qs.stringify(param));
  }, importExercise(param) {
    let config = {headers: {'Content-Type': 'multipart/form-data;'}};
    return post(types.TEACH_PATH + '/exercises/importExercise', param, config);
  }, //=================================== 题库 ===================================
  // 查询题库
  selectExerciseBank(param) {
    return get(types.TEACH_PATH + '/exerciseBank/selectExerciseBank?' + qs.stringify(param));
  }, selectExerciseBankList(param) {
    return get(types.TEACH_PATH + '/exerciseBank/list?' + qs.stringify(param));
  }, // 查询练习库
  selectExercisePractice(param) {
    return get(types.TEACH_PATH + '/exercisePractice/selectExercisePractice?' + qs.stringify(param));
  }, // 更新练习库
  updateExercisePractice(param) {
    return post(types.TEACH_PATH + '/exercisePractice/updateExercisePractice', qs.stringify(param));
  }, // 创建练习库
  createExercisePractice(param) {
    return post(types.TEACH_PATH + '/exercisePractice/createExercisePractice', qs.stringify(param));
  }, // 删除练习库
  deleteExercisePractice(param) {
    return post(types.TEACH_PATH + '/exercisePractice/deleteExercisePractice', qs.stringify(param));
  }, //练习库推送班级
  pushPracticeEntity(param) {
    return post(types.TEACH_PATH + '/exercisePractice/pushPracticeEntity', qs.stringify(param));
  }, //练习库撤销推送班级
  recallPracticeEntity(param) {
    return post(types.TEACH_PATH + '/exercisePractice/recallPracticeEntity', qs.stringify(param));
  }, // 取得课程下我的练习题库
  getMyEbPracticeList(param) {
    return get(types.TEACH_PATH + '/exercisePractice/getMyEbPracticeList?' + qs.stringify(param));
  }, // 查询练习库日志
  selectPracticePushLog(param) {
    return get(types.TEACH_PATH + '/exercisePracticePushLog/selectExercisePracticePushLog?' + qs.stringify(param));
  }, //下载练习库模板
  downLoadTemplatePracticeExercise(param) {
    return post(types.TEACH_PATH + '/exercises/download/templatePractice?' + qs.stringify(param), {}, {responseType: 'arraybuffer'});
  }, // 上传联系题库试题
  importExercisePractice(param) {
    let config = {headers: {'Content-Type': 'multipart/form-data;'}};
    return post(types.TEACH_PATH + '/exercises/importExercisePractice', param, config);
  }, // 查询练习库
  selectPracticeListByCourseId(param) {
    return get(types.TEACH_PATH + '/exercisePractice/selectPracticeListByCourseId?' + qs.stringify(param));
  }, // 将试题库中试题导入到练习库
  importExercisesFromBankToPractice(param) {
    return put(types.TEACH_PATH + '/exercises/importExercisesFromBankToPractice?' + qs.stringify(param));
  }, //取得练习题库下的试题
  GetPracticeExercisesList(param) {
    return post(types.TEACH_PATH + '/exercises/selectExercisesByPracticeIds?' + qs.stringify(param));
  }, // 根据课程id查询练习库自定义名称
  selectAutoQuestionByPracticeCourseId(param) {
    return post(types.TEACH_PATH + '/exercisePaper/selectAutoQuestionByPracticeCourseId', qs.stringify(param));
  }, // 取得课程下我的试题库和共享试题库
  getMyAndSharedEbList(param) {
    return get(types.TEACH_PATH + '/exerciseBank/getMyAndSharedEbList?' + qs.stringify(param));
  }, // 创建题库
  createExerciseBank(param) {
    let config = {headers: {'Content-Type': 'application/json'}};
    return post(types.TEACH_PATH + '/exerciseBank/createExerciseBank/', param, config);
  }, // 更新题库
  updateExerciseBank(param) {
    return post(types.TEACH_PATH + '/exerciseBank/updateExerciseBank', qs.stringify(param));
  }, // 编辑题库
  editExerciseBank(param) {
    return put(types.TEACH_PATH + '/exerciseBank', qs.stringify(param));
  }, // 删除题库
  deleteExerciseBank(param) {
    return post(types.TEACH_PATH + '/exerciseBank/deleteExerciseBank', qs.stringify(param));
  }, getExercisesLibShareSchool(param) {
    return get(types.TEACH_PATH + '/sys/school/getExercisesLibShareSchool?' + qs.stringify(param));
  }, findSchoolByBankId(param) {
    return get(types.TEACH_PATH + '/exerciseBank/findSchoolByBankId?' + qs.stringify(param));
  }, checkSchoolByBankId(param) {
    return get(types.TEACH_PATH + '/exerciseBank/checkSchoolByBankId?' + qs.stringify(param));
  }, updateExercisesBankEntity(param) {
    return post(types.TEACH_PATH + '/exerciseBank/updateExercisesBankEntity', qs.stringify(param));
  }, shareExercisesBankToASchool(param) {
    return post(types.TEACH_PATH + '/exerciseBank/shareExercisesBankToASchool', qs.stringify(param));
  }, delShareExercisesBankToASchool(param) {
    return post(types.TEACH_PATH + '/exerciseBank/delShareExercisesBankToASchool', qs.stringify(param));
  }, selectShareExerciseBank(param) {
    return get(types.TEACH_PATH + '/exerciseBank/selectShareExerciseBank?' + qs.stringify(param));
  }, // 导出题库（单多判填空简单综合题）
  exportExerciseBank(param) {
    return get(types.TEACH_PATH + '/exerciseBank/exportExerciseBank?' + qs.stringify(param));
  }, //=================================== 试卷库 ===================================
  // 创建试卷
  createPaper(param) {
    let config = {headers: {'Content-Type': 'application/json'}};
    return post(types.TEACH_PATH + '/exercisePaper/add', param, config);
  },

  // 编辑试卷
  editPaper(param) {
    let config = {headers: {'Content-Type': 'application/json'}};
    return put(types.TEACH_PATH + '/exercisePaper/edit', param, config);
  }, // 查询试卷列表
  selectExercisePaper(param) {
    return get(types.TEACH_PATH + '/exercisePaper/selectExercisePaper?' + qs.stringify(param));
  }, // 查询试卷列表List
  selectExercisePaperList(param) {
    return get(types.TEACH_PATH + '/exercisePaper/list?' + qs.stringify(param));
  }, // 删除试卷
  deleteExercisePaper(param) {
    return post(types.TEACH_PATH + '/exercisePaper/deleteExercisePaper', qs.stringify(param));
  }, // 根据题库id查询试题
  selectExerciseByPaperId(param) {
    return post(types.TEACH_PATH + '/exercisePaper/selectExercisesByPaperId', qs.stringify(param));
  }, // 根据课程id查询自定义名称
  selectAutoQuestionByCourseId(param) {
    return post(types.TEACH_PATH + '/exercisePaper/selectAutoQuestionByCourseId', qs.stringify(param));
  }, // 移动试题(修改sort)
  moveExerciseInPaper(param) {
    return post(types.TEACH_PATH + '/exercisePaper/moveExerciseInPaper', qs.stringify(param));
  }, // 移动试题(修改sort)
  moveExerciseTypeInPaper(param) {
    return post(types.TEACH_PATH + '/exercisePaper/moveExerciseTypeInPaper', qs.stringify(param));
  }, // 移动试题题库
  moveExerciseInCourse(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/exercisePaper/moveExerciseInCourse', param, config);
  }, // 移动试题
  moveExercise(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/exercisePaper/moveExercise', param, config);
  }, // 根据题库id查询试题数量和分数
  selectExercisesNumAndScore(param) {
    return get(types.TEACH_PATH + '/exercisePaper/selectExercisesNumAndScore?' + qs.stringify(param));
  }, // 物理删除试卷里面的试题
  deleteExerciseInPaper(param) {
    return post(types.TEACH_PATH + '/exercisePaper/deleteExerciseInPaper', qs.stringify(param));
  }, // 移除试卷中一类试题
  deleteExerciseTypeInPaper(param) {
    return post(types.TEACH_PATH + '/exercisePaper/deleteExerciseTypeInPaper', qs.stringify(param));
  }, // 根据课程id查询我的试卷库
  getMyEPList(param) {
    return get(types.TEACH_PATH + '/exercisePaper/getMyEPList?' + qs.stringify(param));
  }, // 试卷设定一道题分数
  updateScoreInPaper(param) {
    return post(types.TEACH_PATH + '/exercisePaper/updateScoreInPaper', qs.stringify(param));
  }, // 试卷批量设定分数
  updateTypeScoreInPaper(param) {
    return post(types.TEACH_PATH + '/exercisePaper/updateTypeScoreInPaper', qs.stringify(param));
  }, // 试卷批量设定综合题子题分数
  updateScoreComprehensive(param) {
    return post(types.TEACH_PATH + '/exercisePaper/updateScoreComprehensive', qs.stringify(param));
  }, // 更新试卷名称
  updateNameInPaper(param) {
    return post(types.TEACH_PATH + '/exercisePaper/updateNameInPaper', qs.stringify(param));
  }, // 查询试卷信息
  selectPaper(param) {
    return get(types.TEACH_PATH + '/exercisePaper/selectPaper?' + qs.stringify(param));
  }, // 保存试卷信息
  savePaper(param) {
    return get(types.TEACH_PATH + '/exercisePaper/savePaper?' + qs.stringify(param));
  }, // 下载试卷word
  downloadWordPaper(param) {
    return post(types.TEACH_PATH + '/exercisePaper/downloadPaper?' + qs.stringify(param));
  }, // 手工组卷创建试卷
  createExercisePaper(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/exercisePaper/createExercisePaper', param, config);
  }, // 手工组卷创建试卷
  updateExercisePaper(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/exercisePaper/updateExercisePaper', param, config);
  }, // 专业组卷-自动组卷创建试卷
  createProfessionalExamPaperForAuto(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/exercisePaper/createProfessionalExercisePaperAuto', param, config);
  }, // 自动组卷创建试卷
  createExercisePaperAuto(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/exercisePaper/createExercisePaperAuto', param, config);
  }, // 自动组卷创建试卷
  selectExercisePaperAutoRead(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/exercises/selectExercisePaperAutoRead', param, config);
  }, // 一键组卷 added by xieyan 20180212
  createExercisePaperByBankId(param) {
    return post(types.TEACH_PATH + '/exercisePaper/createExercisePaperByBankId', qs.stringify(param));
  }, //根据试卷ID获取试卷包含试题的类型和对应数量
  getExerciseTypeCountByPaperId(param) {
    return get(types.TEACH_PATH + '/exercisePaper/selectExercisesTypeCountByPaperId?' + qs.stringify(param));
  }, //添加试卷学校关系表
  addPaperBindSchool(params) {
    return post(types.TEACH_PATH + '/exercisePaperSchool', qs.stringify(params))
  }, //删除试卷学校关系表
  delPaperBindSchool(params) {
    return put(types.TEACH_PATH + '/exercisePaperSchool', qs.stringify(params))
  }, //=================================== 测验 ===================================
  //安排评测
  arrangeExamination(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/examination/arrangeExamination', param, config);
  },

  // 下载试卷word
  downloadWordExamination(param) {
    return post(types.TEACH_PATH + '/examination/downloadPaper?' + qs.stringify(param));
  }, //=================================== 测验报告 ===================================
  //检索测验报告
  selectExaminationReport(param) {
    return get(types.TEACH_PATH + '/examination/selectExaminationReport?' + qs.stringify(param));
  }, //检索最近6次考试报告
  selectExaminationReportLimitSix(param) {
    return get(types.TEACH_PATH + '/moduleOption/selectExaminationReportLimitSix?' + qs.stringify(param));
  }, //得分率
  studentScoringAverage(param) {
    return get(types.TEACH_PATH + '/moduleOption/studentScoringAverage?' + qs.stringify(param));
  }, //考试进步
  studentsExamRanking(param) {
    return get(types.TEACH_PATH + '/moduleOption/studentsExamRanking?' + qs.stringify(param));
  }, //更新报告信息
  updateExaminationReport(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/examination/updateExaminationReport', param, config);
  }, //导出考试
  exportExamReport(param) {
    return get(types.TEACH_PATH + '/examination/exportExamReport?' + qs.stringify(param));
  }, //教务主任导出考试
  exportEducationalAdministratorExamReport(param) {
    return get(types.TEACH_PATH + '/examination/educationalAdministrator/exportExamReport?' + qs.stringify(param));
  }, //导出班级成绩
  exportClassesResults(param) {
    return get(types.TEACH_PATH + '/examination/exportClassesResults?' + qs.stringify(param));
  }, //下载模板
  downLoadTemplateExercise(param) {
    return post(types.TEACH_PATH + '/exercises/download/template?' + qs.stringify(param), {}, {responseType: 'arraybuffer'});
  }, //导出测验
  exportExamination(param) {
    return get(types.TEACH_PATH + '/examination/exportExamination?' + qs.stringify(param));
  }, //导入测验
  importExamination(param) {
    let config = {headers: {'Content-Type': 'multipart/form-data'}}
    return post(types.TEACH_PATH + '/examination/importExamination', param, config);
  }, //过去测验详情
  getExaminationDetails(param) {
    return get(types.TEACH_PATH + '/examination/getExaminationDetails?' + qs.stringify(param));
  }, getExamStuPaper(param) {
    return get(types.TEACH_PATH + '/examination/getExamStuPaper?' + qs.stringify(param));
  }, getExamStuAnswerByExerciseId(param) {
    return get(types.TEACH_PATH + '/examination/getExamStuAnswerByExerciseId?' + qs.stringify(param));
  }, updateExamStuScore(param) {
    return put(types.TEACH_PATH + '/examination/updateExamStuScore', qs.stringify(param));
  }, updateExamStuRemark(param) {
    return post(types.TEACH_PATH + '/remarks/stuAnswerRemark', qs.stringify(param));
  }, //查询每个班级的成绩单
  getExamStuReport(param) {
    return get(types.TEACH_PATH + '/examination/getExamStuReport?' + qs.stringify(param));
  }, //查询测验平均分已经得分率
  getExamClassStuScoreRate(param) {
    return get(types.TEACH_PATH + '/examination/getExamClassStuScoreRate?' + qs.stringify(param));
  }, getExamStuSubmitNum(param) {
    return get(types.TEACH_PATH + '/examination/getExamStuSubmitNum?' + qs.stringify(param));
  }, getExamClassTop10(param) {
    return get(types.TEACH_PATH + '/examination/getExamClassTop10?' + qs.stringify(param));
  }, //根据测试id 查询班级 学生列表
  getExaminationClassInfo(param) {
    return get(types.TEACH_PATH + '/examination/getExaminationClassInfo?' + qs.stringify(param));
  }, //根据测试id 查询测试信息 和学生总分
  selectExaminationInfo(param) {
    return get(types.TEACH_PATH + '/examination/selectExaminationInfo?' + qs.stringify(param));
  }, selectExercisesByExaminationId(param) {
    return get(types.TEACH_PATH + '/examination/selectExercisesByExaminationId?' + qs.stringify(param));
  }, // 查询考试报告
  selectReport(param) {
    return get(types.TEACH_PATH + '/examination/report?' + qs.stringify(param));
  }, // 学校查询考试报告
  selectSchoolReport(param) {
    return get(types.TEACH_PATH + '/examination/school/report?' + qs.stringify(param));
  },getTime(param) {
    return get(types.TEACH_PATH + '/bc/getTime?' + qs.stringify(param));
  }, getGameUserById(param) {
    return get('/w/test/getUser?' + qs.stringify(param));
  }, getGivingTpProcessResourceById(param) {
    return get('/w/test/getResource?' + qs.stringify(param));
  }, getCurrentUserId() {
    return get('/w/test/getCurrentUserId');
  }, getTopScoreAndShortTime(param) {
    return get('/w/test/getTopScoreAndShortTime?' + qs.stringify(param));
  }, saveStudentHead(param) {
    return get(types.TEACH_PATH + '/classManager/saveStudentHead?' + qs.stringify(param));
  }, import3TdRes(param) {
    let config = {headers: {'Content-Type': 'multipart/form-data'}};
    return post(types.RESOURCE_PATH + '/import3Td', param, config);
  }, import3TdData(param) {
    return post(types.TEACH_PATH + '/preparinglesson/teachingPlan/import3TdData', qs.stringify(param));
  }, //=================================== 章管理 ===================================
  // 查询章
  selectExerciseChapter(param) {
    return get(types.TEACH_PATH + '/exerciseChapter/selectExerciseChapter?' + qs.stringify(param));
  }, // 创建章
  createExerciseChapter(param) {
    return post(types.TEACH_PATH + '/exerciseChapter/createExerciseChapter', qs.stringify(param));
  }, // 更新章
  updateExerciseChapter(param) {
    return post(types.TEACH_PATH + '/exerciseChapter/updateExerciseChapter', qs.stringify(param));
  }, // 删除章
  deleteExerciseChapter(param) {
    return post(types.TEACH_PATH + '/exerciseChapter/deleteExerciseChapter', qs.stringify(param));
  }, //=================================== 节管理 ===================================
  // 查询节
  selectExerciseSection(param) {
    return get(types.TEACH_PATH + '/exerciseSection/selectExerciseSection?' + qs.stringify(param));
  }, // 创建节
  createExerciseSection(param) {
    return post(types.TEACH_PATH + '/exerciseSection/createExerciseSection', qs.stringify(param));
  }, // 更新节
  updateExerciseSection(param) {
    return post(types.TEACH_PATH + '/exerciseSection/updateExerciseSection', qs.stringify(param));
  }, // 删除节
  deleteExerciseSection(param) {
    return post(types.TEACH_PATH + '/exerciseSection/deleteExerciseSection', qs.stringify(param));
  }, //发送成绩
  sendResult(param) {
    return get(types.TEACH_PATH + '/examination/sendResult?' + qs.stringify(param));
  }, //获取考试成绩信息
  getEXaminationScore(param) {
    return get(types.TEACH_PATH + '/examination/selectExaminationScoreInfo?' + qs.stringify(param));
  }, //获取考试班级成绩信息
  getEXaminationClassScore(param) {
    return get(types.TEACH_PATH + '/examination/selectExaminationClassScoreInfo?' + qs.stringify(param));
  }, //获取考试班级习题得分率信息
  getExerciseScoreRate(param) {
    return get(types.TEACH_PATH + '/examination/selectExerciseScoreRate?' + qs.stringify(param));
  }, //获取参与考试学生信息
  getParticipantInfo(param) {
    return get(types.TEACH_PATH + '/examination/getExamParticipant?' + qs.stringify(param));
  }, getCourseList(param) {
    return get(types.TEACH_PATH + '/examination/getCourses?' + qs.stringify(param));
  }, //讲解试题
  teachExercise(param) {
    let config = {headers: {'Content-Type': 'application/json'}}
    return post(types.TEACH_PATH + '/examination/teachExercise', param, config);
  },

  //==================班主任对所管理班级考试管理==================
  //检索考试相关课程
  selectClassMasterExaminationCourse(param) {
    return get(types.TEACH_PATH + '/examination/classMaster/selectCourse');
  }, //检索考试相关班级信息
  selectClassMasterExaminationClass(param) {
    return get(types.TEACH_PATH + '/examination/classMaster/selectClassInfo');
  }, //检索考试报告
  selectClassMasterExaminationReport(param) {
    return get(types.TEACH_PATH + '/examination/classMaster/selectExaminationReport?' + qs.stringify(param));
  }, //获取考试报告详细
  selectClassMasterExaminationDetail(param) {
    return get(types.TEACH_PATH + '/examination/classMaster/getExaminationDetails?' + qs.stringify(param));
  }, //导出考试报告
  exportClassMasterExamReport(param) {
    return get(types.TEACH_PATH + '/examination/classMaster/exportExamReport?' + qs.stringify(param));
  },

  //==================教务主任对全校考试管理==================
  //检索考试相关课程
  selectEducationalAdministratorExaminationCourse(param) {
    return get(types.TEACH_PATH + '/examination/educationalAdministrator/selectCourse');
  }, //检索考试相关班级信息
  selectEducationalAdministratorExaminationClass(param) {
    return get(types.TEACH_PATH + '/examination/educationalAdministrator/selectClassInfo');
  }, //检索考试报告
  selectEducationalAdministratorExaminationReport(param) {
    return get(types.TEACH_PATH + '/examination/educationalAdministrator/selectExaminationReport?' + qs.stringify(param));
  }, //获取考试报告详细
  selectEducationalAdministratorExaminationDetail(param) {
    return get(types.TEACH_PATH + '/examination/educationalAdministrator/getExaminationDetails?' + qs.stringify(param));
  }, //导出考试报告
  /*  exportEducationalAdministratorExamReport(param) {
      return get(types.TEACH_PATH + '/examination/educationalAdministrator/exportExamReport?' + qs.stringify(param));
    },*/
  //导出学校考试统计数据
  exportExamStatisticDataResults(param) {
    return get(types.TEACH_PATH + '/examination/educationalAdministrator/exportExamStatisticData?' + qs.stringify(param));
  },

  //===================学生web端答题相关=================
  //获取某学生考试的课程
  getCourses(param) {
    // return get(types.STUDENT_PATH + '/sys/selectCourseList?' + qs.stringify(param));
    return get(types.STUDENT_PATH + '/courses/courseList?' + qs.stringify(param));
  }, // 获取极速考试列表
  getSpeedList(param) {
    return get(types.STUDENT_PATH + '/exams/speedList?' + qs.stringify(param));
  }, // 获取考试进行中
  getCurrentExamList(params) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.STUDENT_PATH + '/exams/current', params, remarks);
  }, // 获取考试未开始
  getFutureExamList(params) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.STUDENT_PATH + '/exams/future', params, remarks);
  }, // 获取考试已结束
  getPastExamList(params) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.STUDENT_PATH + '/exams/past', params, remarks);
  }, //获取某学生某课程对应的考试
  getExamination(param) {
    return get(types.STUDENT_PATH + '/exercises/selectExaminationUser?' + qs.stringify(param));
  }, //查找盖章
  findBillSigns(param) {
    return get(types.STUDENT_PATH + '/exercises/selectStampByExercisesId?' + qs.stringify(param));
  }, //查找划线
  findBillLine(param) {
    return get(types.STUDENT_PATH + '/exercises/selectLineAll?' + qs.stringify(param));
  }, //根据试卷id查询试题
  selectExercisesByExamId(param) {
    return get(types.STUDENT_PATH + '/exercises/selectExercisesByExamId?' + qs.stringify(param));
  }, //更新学生作答已经使用的时间
  updateUsedTime(param) {
    return put(types.STUDENT_PATH + '/exercises/updateUsedTime', param);
  }, //保存学生单多判答案
  saveStudentBasicAnswer(params) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.STUDENT_PATH + '/exercises/saveStudentBasicAnswer', params, remarks);
  }, //保存学生表格题答案
  saveStudentBillAnswer(params) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.STUDENT_PATH + '/exercises/saveStudentBillAnswer', params, remarks);
  }, saveStudentRecordAnswer(params) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.STUDENT_PATH + '/exercises/saveStudentRecordAnswer', params, remarks);
  }, //提交答案
  studentSubmit(params) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.STUDENT_PATH + '/exercises/studentSubmit', params, remarks);
  }, //是否提交
  studentIsSubmit(params) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.STUDENT_PATH + '/exercises/studentIsSubmit', params, remarks);
  }, //查找考试信息
  selectExamInfo(param) {
    // return get(types.STUDENT_PATH + '/exercises/selectExamInfo?' + qs.stringify(param));
    return get(types.STUDENT_PATH + '/exams/selectExamInfo?' + qs.stringify(param));
  }, //查询随堂测验试题信息
  selectPractice(params) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.STUDENT_PATH + '/practice/selectPractice', params, remarks);
  }, //保存随堂练习单多判答案
  savePracticeBasicAnswer(params) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.STUDENT_PATH + '/practice/savePracticeBasicAnswer', params, remarks);
  }, //保存随堂练习表格题答案
  savePracticeBillAnswer(params) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.STUDENT_PATH + '/practice/savePracticeBillAnswer', params, remarks);
  }, //保存随堂练习会计分录题答案
  savePracticeRecordAnswer(params) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.STUDENT_PATH + '/practice/savePracticeRecordAnswer', params, remarks);
  }, //查询学生随堂练习是否提交
  practiceIsSubmit(params) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.STUDENT_PATH + '/practice/practiceIsSubmit', params, remarks);
  }, //查询学生随堂练习提交
  practiceSubmit(params) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.STUDENT_PATH + '/practice/practiceSubmit', params, remarks);
  }, //获取学生成绩单
  getMobileExamStuReport(params) {
    return get(types.STUDENT_PATH + '/examination/getExamStuReport?' + qs.stringify(params));
  }, //获取手机排名班级
  getMobileExaminationDetails(params) {
    return get(types.STUDENT_PATH + '/examination/getExaminationDetails?' + qs.stringify(params));
  }, getPaperCourseList(params) {
    return get(types.TEACH_PATH + '/exercisePaper/paperCourseList?' + qs.stringify(params));
  }, // 获取分录描述
  getArGroupDescList(param) {
    return get(types.STUDENT_PATH + '/exercises/getArGroupDescList?' + qs.stringify(param));
  }, //创建切屏
  createCutScreen(params) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.STUDENT_PATH + '/exams/createCutScreen', params, remarks);
  }, //更新切屏
  upCutScreen(params) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.STUDENT_PATH + '/exams/upCutScreen', params, remarks);
  }, //更新最后一条切屏时间
  upCutScreenFinally(params) {
    let remarks = {headers: {'Content-Type': 'application/json'}};
    return post(types.STUDENT_PATH + '/exams/upCutScreenFinally', params, remarks);
  }, // 获取用户信息
  getUserInfo(param) {
    return get(types.STUDENT_PATH + '/users/getInfo?' + qs.stringify(param));
  }, //更新学生观看视频时间
  updateWatchTime(param) {
    return put(types.STUDENT_PATH + '/exercises/updateWatchTime', param);
  },
  getKQStudent(param) {
    return get('/fixtures/getKQStudent?' + qs.stringify(param));
  },
}



// WEBPACK FOOTER //
// ./src/fetch/http.js